module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row select"
  }, [_c('div', {
    staticClass: "col-md-12 select-choices",
    class: {
      editable: _vm.isEditable
    }
  }, [_c('draggable', {
    staticClass: "choice-container",
    attrs: {
      "group": "choices",
      "ghost-class": "choice-ghost",
      "draggable": ".draggable"
    },
    model: {
      value: (_vm.computedValue),
      callback: function($$v) {
        _vm.computedValue = $$v
      },
      expression: "computedValue"
    }
  }, [_vm._l((_vm.computedValue), function(choice) {
    return _c('select-choice-item', {
      key: choice.id,
      class: {
        draggable: _vm.isEditable
      },
      attrs: {
        "choice": choice,
        "question": _vm.question,
        "isEditable": _vm.isEditable
      },
      on: {
        "onUpdateChoice": _vm.handleUpdateChoice,
        "onEmpty": function($event) {
          return _vm.handleRemove(choice.id)
        },
        "onRemove": function($event) {
          return _vm.handleRemove(choice.id)
        }
      }
    })
  }), _vm._v(" "), (_vm.isEditable) ? _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('div', {
    staticClass: "placeholder-container"
  }, [_vm._v("\n            Drag choice or\n            "), _c('a', {
    on: {
      "click": _vm.handleCreateChoice
    }
  }, [_vm._v("Create a new choice")])])]) : _vm._e()], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "options"
  }, [(_vm.isEditable) ? _c('el-button', {
    attrs: {
      "size": "mini"
    },
    on: {
      "click": _vm.handleClear
    }
  }, [_c('i', {
    staticClass: "fa fa-trash"
  }), _vm._v("   Clear all choices\n      ")]) : _vm._e(), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "mini",
      "disabled": !_vm.isValid
    },
    on: {
      "click": _vm.handleSaveTemplate
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v("   Save as new Choice Template\n      ")])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6a5e07e8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/surveybuilder/editors/select/SelectEditorExpanded.vue
// module id = 3322
// module chunks = 3